import { render } from "./Services.vue?vue&type=template&id=e0de0e42&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=e0de0e42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e0de0e42"

export default script